var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BFormRadioGroup',{attrs:{"options":_vm.options},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }